import React from 'react';

// components and helpers
import ComponentWrapper from '../containers/ComponentWrapper';
import AuditWrapper from '../components/Audit/AuditWrapper';

export const AuditView: React.FC = () => {
    return <AuditWrapper />;
};

export default ComponentWrapper(AuditView);
